import { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { actions } from 'containers/PolicyHub/Blueprints/slice';

export const useBlueprint = () => {
  const dispatch = useDispatch();

  const params = useParams<{ id: string }>();

  const getBlueprint = useCallback(() => {
    if (!!params.id) {
      dispatch(
        actions.getBlueprintByID({
          q: { blueprintId: params.id },
        }),
      );
      dispatch(actions.getBlueprintSummary({ q: { blueprintId: params.id } }));
      dispatch(
        actions.getAttachedWorkflows({
          q: { policyId: params?.id },
        }),
      );
    }
  }, [dispatch, params]);

  return {
    getBlueprint,
  };
};
